// Workaround for Vite not having a global variable
window.global ||= window;
